import { Icon } from "@thetreep/ui";
import { useRef, useState } from "react";
import { getMenuActions, MenuActionProps } from "@utils/profileMenu";
import { User } from "@gen/user/v1/user_pb";
import { useTranslation } from "react-i18next";

export interface ProfileMenuProps {
  user: User;
  onLogout: () => void;
  onNavigate: (id: string) => void;
}

export function ProfileMenuMobile({
  user,
  onLogout,
  onNavigate,
}: ProfileMenuProps) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const menuActions: MenuActionProps[] = [
    {
      label: t("header.home"),
      iconSrc: "home_fill",
      iconColor: "#09244B",
      testId: "home-button",
      action: () => onNavigate("home"),
      isVisible: true,
    },
    {
      label: t("header.bookJourney"),
      iconSrc: "search_line",
      testId: "search-button",
      action: () => onNavigate("search"),
      isVisible: true,
    },
    ...getMenuActions(user, onLogout, onNavigate),
  ];

  const openSidePanel = () => {
    setIsOpen(true);
  };

  const close = () => {
    setIsOpen(false);
  };

  const handleAction = (action?: () => void) => {
    action?.();
    close();
  };

  return (
    <div ref={menuRef} className="relative">
      <div className="md:hidden items-center gap-10 flex">
        <Icon src="menu_line" size={24} onClick={openSidePanel} />
      </div>

      {isOpen && (
        <div
          className="fixed z-[1000] inset-0 bg-black opacity-50 transition-opacity duration-500"
          onClick={close}
        />
      )}

      <div
        className={`fixed z-[1001] top-0 right-0 w-[70%] max-w-[300px] h-full bg-white shadow-lg z-50 py-6 
        transform transition-transform duration-500 
        ${isOpen ? "translate-x-0" : "translate-x-full"}`}
      >
        <div className="absolute p-2 top-0 right-0" onClick={close}>
          <Icon src="close_line" size={30} onClick={openSidePanel} />
        </div>

        <div className="mt-8">
          <div className="flex flex-col ml-6 mb-6">
            <p className="text-sm ">
              {user.firstName} {user.lastName}
            </p>
            <p className="text-xs">{user.email}</p>
          </div>
          {menuActions.map(
            (action, index) =>
              action.isVisible && (
                <button
                  key={index}
                  data-testid={action.testId}
                  onClick={() => handleAction(action.action)}
                  className="flex items-center font-bold min-w-[276px] gap-2 w-full px-6 py-3 text-sm hover:bg-gray-100"
                >
                  <Icon src={action.iconSrc} color={action.iconColor} />
                  {action.label}
                </button>
              ),
          )}
        </div>
      </div>
    </div>
  );
}
